import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FixedTableCell } from "./FixedTableCell";
import TableFixedHeaderWraper from "./TableWithFixedHeader";

const ShipmentsTable = (props) => {
  const {
    page,
    rowsPerPage,
    headCells,
    data,
    parseBodyCell,
    total,
    sumRow,
    classes,
    sumTableNumber,
    checkAll,
    invoiceQ,
    sum,

    ...restProps
  } = props;
  const { t } = useTranslation();
  const tableTotal = { ...total };
  if (!sum) {
    data &&
    data.forEach((shipment) => {
      return sumTableNumber
        ? sumTableNumber(shipment, tableTotal)
        : Object.entries(tableTotal).forEach(([k, v]) => {
          tableTotal[k] += shipment.shipment[k] ?? 0;
        });
    });
  }

  const tableData =
    (rowsPerPage
      ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : data) ?? [];

  return (
    <Table
      {...restProps}
      aria-labelledby="tableTitle"
      aria-label="enhanced table"
    >
      <TableHead className={classes?.tableHead}>
        <TableRow>
          {checkAll && checkAll}
          {headCells.map((headCell, index) => {
            return headCell !== null ? (
              <FixedTableCell
                className={classes?.[`shipmentTable_${headCell}`]}
                key={index}
              >
                {t(headCell)}
              </FixedTableCell>
            ) : null;
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {tableData.map(parseBodyCell)}
        {sumRow ??
          (data.length > 0 && (
            <TableRow role="checkbox" tabIndex={-1}>
              <FixedTableCell
                colSpan={
                  headCells.length - 2 - Object.entries(tableTotal).length
                }
              > </FixedTableCell>
              <FixedTableCell variant="head">{t("total")}</FixedTableCell>
              {Object.entries(tableTotal).map(([k, v], index) => {
                return (
                  <FixedTableCell variant="head" key={index}>
                    {sum ? v : v?.toFixed(2)}
                  </FixedTableCell>
                );
              })}
              {!headCells.some((i) => i === null) && (
                <FixedTableCell> </FixedTableCell>
              )}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

ShipmentsTable.propTypes = {
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  headCells: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  parseBodyCell: PropTypes.func.isRequired,
  total: PropTypes.object,
  sumRow: PropTypes.any,
  classes: PropTypes.any,
};
export default ShipmentsTable;
